import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { ColdHubPageData } from '@/types/dashboard/ColdHubPage';
// import { getArmadoresList } from '@/services/getListArmadores';
import { getDashboardColdHubPageData } from '@/services/dashboardColdHubPage';
import useAuthContext from '../useAuthContext';

export const useColdHubPage = () => {
  const { userDataDecoded } = useAuthContext();
  const [currentCliente, setCurrentCliente] = useState({ value: '', name: '' });
  const [coldHubPageData, setColdHubPageData] = useState<ColdHubPageData>();
  const [isInitialPageData, setIsInitialPageData] = useState(true);
  const [isInitialCliente, setIsInitialCliente] = useState(true);

  // Obtener la lista de armadores
  //   const { data: armadoresList, isLoading: loadingArmadores } = useQuery({
  //     queryKey: ['armadoresListDropdown'],
  //     queryFn: getArmadoresList,
  //   }); Consultar si hay un getClients

  // Obtener los datos de la página basado en el viaje actual
  const { data: pageData, isLoading: loadingPageData } = useQuery({
    queryKey: ['coldHubPageData', currentCliente.value], // Asegurar que cliente.value es parte de la queryKey
    queryFn: () =>
      getDashboardColdHubPageData({ cliente: currentCliente.value }),
    enabled: currentCliente.value !== '', // Habilitar solo si currentCliente.value no está vacío
  });

  // Generar opciones para el dropdown de armadores
  const clientOptions = userDataDecoded?.cliente_hub_frio
    ?.split(';')
    .map((val) => {
      return { value: val, name: val };
    });
  //   const clientListOptions = armadoresList?.map(
  //     (val: { codigo: string; nombre: string }) => {
  //       return { value: val.codigo, name: val.nombre };
  //     }
  //   ); // Desde el endpoint armamos la lista, preguntar si hay un getClients

  // const clientesListForDropdown =
  //   userDataDecoded?.armadores === '*' ? clientListOptions : options; Si hay endpoint client, aca validamos y comparamos con lo que viene en JWT.

  // Efecto para inicializar currentArmador una vez
  useEffect(() => {
    if (isInitialCliente && clientOptions && clientOptions.length > 0) {
      setCurrentCliente(clientOptions[0]);
      setIsInitialCliente(false); // Marcar como ejecutado
    }
  }, [isInitialCliente, clientOptions]);

  useEffect(() => {
    if (isInitialPageData && pageData) {
      setColdHubPageData(pageData);
      setIsInitialPageData(false); // Marcar como ejecutado
    }
  }, [isInitialPageData, pageData]);

  useEffect(() => {
    if (pageData) {
      setColdHubPageData(pageData);
    }
  }, [pageData]);

  return {
    clientOptions,
    currentCliente,
    setCurrentCliente,
    setColdHubPageData,
    coldHubPageData,
    pageData,
    loadingPageData,
  };
};
